import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { RestorableCarnetDeNotes } from 'containers/CarnetsDeNotes/types/carnetsDeNotes';

export const CDN_TRASH_KEY = 'cdn_trash';

function fetchCarnetsDeNotesTrash() {
  const requestURL = '/carnets-de-notes/trash';
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: RestorableCarnetDeNotes[] }) => data || []);
}

export function useCarnetsDeNotesTrash() {
  return useQuery({
    queryKey: [CDN_TRASH_KEY],
    queryFn: () => fetchCarnetsDeNotesTrash(),
    placeholderData: [],
    refetchOnWindowFocus: false,
  });
}
